module.exports = __webpack_public_path__ + "static/media/maxSuccessionWins_20_25.2a4a5d0f.png";